interface BodyStyleSnapshot {
  position: string;
  top: string;
  left: string;
  right: string;
  width: string;
  overflow: string;
}

interface HtmlStyleSnapshot {
  overflow: string;
}

interface LockSnapshot {
  scrollY: number;
  body: BodyStyleSnapshot;
  html: HtmlStyleSnapshot;
}

let lockCount = 0;
let snapshot: LockSnapshot | null = null;

export const lockBodyScroll = (): void => {
  if (typeof window === 'undefined') return;
  if (!document?.body || !document?.documentElement) return;

  lockCount += 1;
  if (lockCount > 1) return;

  const body = document.body;
  const html = document.documentElement;

  snapshot = {
    scrollY: window.scrollY,
    body: {
      position: body.style.position,
      top: body.style.top,
      left: body.style.left,
      right: body.style.right,
      width: body.style.width,
      overflow: body.style.overflow,
    },
    html: {
      overflow: html.style.overflow,
    },
  };

  body.style.position = 'fixed';
  body.style.top = `-${snapshot.scrollY}px`;
  body.style.left = '0';
  body.style.right = '0';
  body.style.width = '100%';
  body.style.overflow = 'hidden';
  html.style.overflow = 'hidden';
};

export const unlockBodyScroll = (): void => {
  if (typeof window === 'undefined') return;
  if (!document?.body || !document?.documentElement) return;

  lockCount = Math.max(0, lockCount - 1);
  if (lockCount !== 0) return;
  if (!snapshot) return;

  const body = document.body;
  const html = document.documentElement;
  const { scrollY, body: bodySnapshot, html: htmlSnapshot } = snapshot;

  body.style.position = bodySnapshot.position;
  body.style.top = bodySnapshot.top;
  body.style.left = bodySnapshot.left;
  body.style.right = bodySnapshot.right;
  body.style.width = bodySnapshot.width;
  body.style.overflow = bodySnapshot.overflow;
  html.style.overflow = htmlSnapshot.overflow;

  window.scrollTo(0, scrollY);
  snapshot = null;
};
